export const TENANT_PRESET_COLORS = ['default', 'theme1', 'theme2', 'theme3', 'theme4', 'theme5', 'theme6'];
export const DEFAULT_TENANT_PRESET_COLOR = 'default';

export const normaliseTenantPresetColor = (presetColor) =>
    TENANT_PRESET_COLORS.includes(presetColor) ? presetColor : DEFAULT_TENANT_PRESET_COLOR;

export const getTenantPresetColorFromSettings = (settings = {}) => normaliseTenantPresetColor(settings?.branding?.presetColor);

const normaliseTenantLogo = (logo) => (typeof logo === 'string' && logo ? logo : null);

export const getTenantBrandingFromPublicResponse = (branding = {}) => ({
    presetColor: normaliseTenantPresetColor(branding?.presetColor),
    enterpriseLogo: normaliseTenantLogo(branding?.logo),
    enterpriseLogoDark: normaliseTenantLogo(branding?.logoDark),
    loginWallpaper: normaliseTenantLogo(branding?.loginWallpaper)
});

export const getTenantBrandingFromSettings = (settings = {}) => ({
    presetColor: getTenantPresetColorFromSettings(settings),
    enterpriseLogo: normaliseTenantLogo(settings?.branding?.logo),
    enterpriseLogoDark: normaliseTenantLogo(settings?.branding?.logoDark),
    loginWallpaper: normaliseTenantLogo(settings?.branding?.loginWallpaper)
});

export const getTenantLogoUrl = (logo) =>
    logo?.startsWith('http') ? logo : `${process.env.REACT_APP_API?.replace(/\/$/, '') || ''}${logo || ''}`;

export const createTenantAppearanceRequestTracker = () => {
    let latestRequestId = 0;

    return {
        begin: () => {
            latestRequestId += 1;
            return latestRequestId;
        },
        isCurrent: (requestId) => requestId === latestRequestId,
        invalidate: () => {
            latestRequestId += 1;
        }
    };
};
